import type { SVGAttributes } from 'react';
import type { RepresentationData } from '@ardoq/data-model';
import { Rect } from './Rect';
import {
  ArdoqIconCategory,
  ArdoqSvgImageElement,
  type CustomArdoqImageProps,
  SvgIcon,
  fontAwesomeIcons,
  getIcon,
} from '@ardoq/icons';
import { FontAwesomeSvgText } from './FontAwesomeSvgText';

type SvgComponentRepresentationArgs = {
  bounds: Rect;
  representationData: RepresentationData;
  clipPath?: SVGAttributes<SVGElement>['clipPath'];
  customArdoqImageProps?: CustomArdoqImageProps;
};

export const SvgComponentRepresentation = ({
  representationData: { isImage, icon = getIcon(''), value },
  bounds: { left, top, width, height },
  clipPath,
  customArdoqImageProps,
}: SvgComponentRepresentationArgs) => {
  if (isImage && value !== null) {
    return (
      <ArdoqSvgImageElement
        x={left}
        y={top}
        width={width}
        height={height}
        clipPath={clipPath}
        href={value ?? ''}
        {...customArdoqImageProps}
      />
    );
  } else if (icon.isSVG)
    return (
      <SvgIcon
        iconId={icon.id}
        left={`${left}`}
        top={`${top}`}
        width={`${width}`}
        height={`${height}`}
        scale={icon.scale}
        clipPath={clipPath}
      />
    );
  else if (icon.category === ArdoqIconCategory.FontAwesome) {
    return (
      <FontAwesomeSvgText
        fontSize={height}
        x={left + height / 2}
        y={top + height / 2}
        clipPath={clipPath}
      >
        {fontAwesomeIcons[icon.id]}
      </FontAwesomeSvgText>
    );
  }
  return null;
};
